'use strict';
import React, { Component } from 'react';
import { WidgetInstance } from 'friendly-challenge';
import * as constants from '../../constants/FriendlyCaptchaConstants';
import PropTypes from "prop-types";
import FriendlyCaptchaApi from "../../api/friendlyCaptchaApi";
import * as ajaxActions from "../../actions/ajaxCounterActions";
import { throwException } from "../../actions/exceptionActions";

class FriendlyCaptcha extends Component {
	constructor(props, context) {
		super(props, context);

	}

	componentDidMount() {
		this.widget = new WidgetInstance(this.container, {
			doneCallback: (solution) => this.doneCallback(solution, this.props.onVerified),
			errorCallback: (errors) => this.errorCallback(errors, this.props.onVerified),
			sitekey: constants.SITE_KEY,
			language: 'nl'
		});
	}

	componentWillUnmount() {
		if (this.widget)
			this.widget.destroy();
	}

	doneCallback(solution, onVerified) {
		const model = {
			solution: solution
		};

		ajaxActions.started();
		return FriendlyCaptchaApi.Verify(model)
			.then((response) => {
				ajaxActions.ended();

				if (response.data && onVerified){
					onVerified(response.data.verified);
				} else if (onVerified) {
					onVerified(false);
				}
			})
			.catch((ex) => {
				ajaxActions.failed();

				if (onVerified) {
					onVerified(false);
				}
				throwException(ex);
			});
	}

	errorCallback(err, onVerified) {
		if (onVerified) {
			onVerified(false);
		}
	}

	render() {
		return <div ref={(element) => this.container = element} className="frc-captcha" />;
	}
}

FriendlyCaptcha.propTypes = {
	onVerified: PropTypes.func.isRequired,
};

export default FriendlyCaptcha;
